module.exports = __webpack_public_path__ + "static/media/Illus-SummerEarly.6b0c5dac.png";